import type {RingTargetState} from '@phonehq/rtc-core';

const CLOCK_SLACK_MS = 5_000;

const ringedSince = (target: RingTargetState, since: number | undefined): boolean => {
    if (since === undefined) {
        return true;
    }
    const updatedAt = Date.parse(target.updatedAt);
    return Number.isNaN(updatedAt) || updatedAt >= since - CLOCK_SLACK_MS;
};

export const inviteesOf = (targets: readonly RingTargetState[], inCall: ReadonlySet<string>, since?: number): readonly RingTargetState[] =>
    targets.filter(target => !inCall.has(target.matrixUserId) && target.status !== 'ANSWERED' && ringedSince(target, since));

export const isRinging = (target: RingTargetState): boolean => target.status === 'RINGING' || target.status === 'SILENT';
